// Generated from Lane's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type LaneCollectionFilterGroups
  = | {
    readonly sectorSpot: Iri | Iri[]
  }
  | {
    readonly id: Iri
  }

export const laneCollectionFilterMapping: FilterDefinitionMapping<LaneCollectionFilterGroups> = {
  sectorSpot: 'sector.spot',
  id: 'id',
}

export type LaneCollectionSort = 'name' | 'sector.name'
